"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPricingZoneQuery = exports.ProductPricingZoneUpdateTransport = exports.ProductPricingZoneCreateTransport = exports.ProductPricingZoneTransport = exports.ProductPricingSKUTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const ca_state_1 = require("./ca-state");
const pricing_zone_1 = require("./pricing-zone");
const us_state_1 = require("./us-state");
exports.ProductPricingSKUTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    skuID: typebox_1.Type.String({ format: 'uuid' }),
    familyID: typebox_1.Type.String({ format: 'uuid' }),
    metadata: common_1.MetaData,
});
exports.ProductPricingZoneTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    serviceAreas: typebox_1.Type.Array(pricing_zone_1.ServiceArea),
    vendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    vendorName: typebox_1.Type.Optional(typebox_1.Type.String()),
    SKUs: typebox_1.Type.Array(exports.ProductPricingSKUTransport),
    active: typebox_1.Type.Boolean(),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    type: pricing_zone_1.ZoneType,
    state: typebox_1.Type.Union([us_state_1.UsStateAbbreviation, ca_state_1.CAProvinceAbbreviation]),
    zoneName: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: common_1.MetaData,
});
exports.ProductPricingZoneCreateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ProductPricingZoneTransport, ['id', 'SKUs', 'active', 'metadata', 'serviceAreas']),
    typebox_1.Type.Object({
        skuIDs: typebox_1.Type.Array(typebox_1.Type.Object({
            skuID: typebox_1.Type.String({ format: 'uuid' }),
            familyID: typebox_1.Type.String({ format: 'uuid' }),
        })),
    }),
]);
exports.ProductPricingZoneUpdateTransport = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ProductPricingZoneTransport, [
        'id',
        'SKUs',
        'metadata',
        'serviceAreas',
        'type',
        'vendorID',
        'vendorName',
        'active',
    ]),
    typebox_1.Type.Object({
        skuIDs: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Object({
            skuID: typebox_1.Type.String({ format: 'uuid' }),
            familyID: typebox_1.Type.String({ format: 'uuid' }),
        }))),
    }),
]));
exports.ProductPricingZoneQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    lat: typebox_1.Type.Optional(typebox_1.Type.Number()),
    lng: typebox_1.Type.Optional(typebox_1.Type.Number()),
    vendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    active: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    skuID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    familyID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    state: typebox_1.Type.Optional(typebox_1.Type.Union([us_state_1.UsStateAbbreviation, ca_state_1.CAProvinceAbbreviation])),
}));
//# sourceMappingURL=product-pricing-transport.js.map